import { Workbox } from 'workbox-window';
import { getTexts } from '@twnel/web-components';

const reloadPage = () => window.location.reload();

export default function registerServiceWorker(store, { reload = reloadPage } = {}) {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  const workbox = new Workbox('/serviceWorker.js');
  workbox.addEventListener('waiting', () => {
    const texts = getTexts(store.getState());
    // eslint-disable-next-line no-alert
    if (window.confirm(texts('A new version of Twnel is available. Reload now?'))) {
      workbox.addEventListener('controlling', reload);
      workbox.messageSkipWaiting();
    }
  });
  window.addEventListener('load', async () => {
    const workerRegistration = await workbox.register();
    store.dispatch((dispatch, getState, getContext) => {
      const { updateContext } = getContext();
      updateContext({ workerRegistration });
    });
  });
}
